@if (src()) {
  <img
    class="w-full h-full object-cover"
    loading="lazy"
    [src]="src()"
    [alt]="alt() ?? ''"
    (load)="handleImageLoad()"
  />
}

<div
  class="block transition-all transition-discrete opacity-100 group-[.loaded]:opacity-0 group-[.loaded]:hidden"
>
  <ng-content></ng-content>
</div>
